export const asExpandArrowIcon = {
  data: `
    <svg class="h-5 w-5" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
    </svg>`,
  name: 'solid/expand-arrow'
};
